import { helpers, maxLength, minLength, required, requiredIf } from '@vuelidate/validators';
import { validZIPInternational, validZIPUS } from '@core/services/custom-validators';
import LOCALIZATION from '../Localization';
import { SupportedLanguages } from '@core/_types/sharedTypes';

export default class AddressBase {
	addressLine1: string = null;
	addressLine2: string = null;
	city: string = null;
	state: string = null;
	zipCode: string = null;
	country: string = null;
	county: string = null;
	usTerritory: string = null;
	usingAddressExtra?: boolean = null;
	usingUSAddress?: boolean = null;

	constructor(init?: Partial<AddressBase>) {
		if (init) {
			this.addressLine1 = init.addressLine1;
			this.addressLine2 = init.addressLine2;
			this.city = init.city;
			this.state = init.state;
			this.zipCode = init.zipCode;
			this.country = init.country;
			this.county = init.county;
			this.usTerritory = init.usTerritory;
		}

		this.usingAddressExtra = this.addressLine1 || this.zipCode || this.city || this.state || this.county ? !!this.addressLine2 : null;
		this.usingUSAddress = this.country != null ? this.country == 'US' : null;
	}

	getFullAddress() {
		const concatenatedAddress = [this.addressLine1, this.addressLine2, this.city, this.state, this.zipCode, this.country].filter(part => part).join(', ');

		return concatenatedAddress;
	}

	validation(language: SupportedLanguages = 'English') {
		const requiredWithMessage = (message: string) => helpers.withMessage(message, required);
		const requiredIfWithMessage = (message: string, condition: boolean) => helpers.withMessage(message, requiredIf(condition));
		const validWithMessage = (message: string, validator: () => boolean) => helpers.withMessage(message, validator);

		const validationRules: any = {
			addressLine1: {
				required: requiredWithMessage(LOCALIZATION.customerPortalAddBusinessForm.addressLine1Required[language]),
			},
			city: {
				required: requiredWithMessage(LOCALIZATION.customerPortalAddBusinessForm.cityRequired[language]),
			},
			state: {
				required: requiredWithMessage(LOCALIZATION.customerPortalAddBusinessForm.stateRequired[language]),
				minLength: this.usingUSAddress == false ? {} : minLength(2),
				maxLength: this.usingUSAddress == false ? {} : maxLength(2),
			},
			zipCode: {
				required: requiredWithMessage(LOCALIZATION.customerPortalAddBusinessForm.zipCodeRequired[language]),
				validZIPUS: validWithMessage(LOCALIZATION.customerPortalAddBusinessForm.invalidZip[language], () => {
					if (this.usingUSAddress !== false) {
						return validZIPUS(this.zipCode);
					}
					return true;
				}),
				validZIPInternational: validWithMessage(LOCALIZATION.customerPortalAddBusinessForm.invalidZip[language], () => {
					if (this.usingUSAddress == false) {
						return validZIPInternational(this.zipCode);
					}
					return true;
				}),
			},
			county: {
				required: requiredIfWithMessage(LOCALIZATION.customerPortalAddBusinessForm.countyRequired[language], this.usingUSAddress),
			},

			usingUSAddress: {
				required: requiredWithMessage(LOCALIZATION.customerPortalAddBusinessForm.radioQuestionRequired[language]),
			},
		};

		return validationRules;
	}
}
